import { createSlotRecipe } from './runtime.js';

const ghostTextFieldConfig = {"name":"ghostTextField","slots":["root","textarea","endAdornment"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const ghostTextField = /* @__PURE__ */ createSlotRecipe(ghostTextFieldConfig)